import React, { useEffect } from 'react';
import styles from '@/styles/global.module.scss';
import CategoryBar from '../components/common/category-bar';
import { useLanguage } from '@/hooks/use-language';
import { useRouter } from 'next/router';
import { error, info } from '@/utils/safetyLog';
const Custom404 = () => {
  const language = useLanguage();
  const router = useRouter();

  useEffect(() => {
    setTimeout(() => {
      const targetUrl = window.location.origin + (router.asPath?.includes('/en/') ? '/en/blog/' : '/zh/blog/');
      router.replace(targetUrl);
    }, 3000);
  }, []);

  return (
    <div className={styles.not_found_page}>
      <p>{router.asPath?.includes('/en/') ? 'The page you are visiting does not exist' : '您訪問的頁面不存在'}</p>
    </div>
  );
};
export default Custom404;
